const GA_TRACKING_ID = {
  ar: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_AR!,
  cl: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_CL!,
  co: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_CO!,
  ec: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_EC!,
  pe: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_PE!,
  uy: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_UY!,
  br: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_BR!,
  mx: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_MX!
} as const

const DEFAULT_GTM_ID = process.env.NEXT_PUBLIC_GA4_TRACKING_ID_DEFAULT

export const getGtmId = (locale: string) => {
  // Gets the GTM ID for the given locale or returns the default one.
  return GA_TRACKING_ID[locale as keyof typeof GA_TRACKING_ID] || DEFAULT_GTM_ID
}
